export const getAuthToken = () => {
  return localStorage.getItem("token") || null;
};

export const setAuthDetails = (accessToken) => {
  localStorage.setItem("token", accessToken);
};

export const deleteAuthDetails = () => {
  localStorage.removeItem("token");
};
